export const BRANDS_ABOUT_LABEL = {
	title: 'For CPG Brands',
	content_subititle: 'Your Brand, Always On',
	highlight_content:
		'Beacon Discovery helps natural products brands gain visibility and connect with key industry stakeholders year-round.',
	content1:
		'Whether you’re exhibiting at Expo West or seeking ongoing exposure, Beacon gives your brand a place to stand out and be discovered—on and off the show floor.',
	content2: 'It’s the first online discovery platform built with ',
	linkText: 'New Hope Network’s standards ',
	linkContent: 'https://standards.newhope.com/',
	content3:
		'for transparency, integrity, and ingredient quality—plus powerful filters to help buyers find exactly what they’re looking for.',
	videoLink: '834404470',
	videoHash: 'fe6c2597ef'
};
